import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { tap } from 'rxjs/operators'
import { AuthService } from './auth.service'
import { SharedService } from './shared.service'

@Injectable({
    providedIn: 'root',
})
export class ContactService {
    constructor(private authService: AuthService, private sharedService: SharedService, private router: Router) {}

    read(params, queryParams, kind) {
        const admin = queryParams.admin === 'true'
        const bootswatch = queryParams.bootswatch
        const language = params.language

        const opts = { params: { admin } }

        // Remove one time params
        this.router.navigate([], { queryParams: { admin, bootswatch } })

        const url = `/api/form/contact/${language}/${kind}`
        return this.authService.get(url, opts).pipe(tap((res) => this.sharedService.companyUpdate(res.data.company, bootswatch)))
    }

    submit(contactId, contact) {
        const url = `/api/contact/${contactId}/send/`
        const data = { contact }
        return this.authService.post(url, data)
    }

    validateCaptcha(contact) {
        const url = `/api/contact/${contact._id}/captcha/validate`
        return this.authService.get(url)
    }
}
